import { base, mainnet, optimism } from 'viem/chains'

import { SupportedChainId } from '~/constants/chains'
import { IAddress } from '~/types'

const getChainNameFromChainId = (chainId: SupportedChainId) => {
  if (chainId === mainnet.id) return 'ethereum'
  if (chainId === base.id) return 'base'
  if (chainId === optimism.id) return 'optimism'
  return
}

export const getOpenSeaURL = (
  chainId: SupportedChainId,
  tokenAddress: IAddress,
  tokenId: string,
) => {
  const networkName = getChainNameFromChainId(chainId)
  if (!networkName) return
  else
    return `https://opensea.io/assets/${networkName}/${tokenAddress}/${tokenId}`
}
